import { get, post } from 'services/api';
import type { DataFeed, NewDataFeed } from 'modules/dataFeeds/types';

export const DELETE_DATA_FEED_URL = '/settings/dataFeeds/delete';
export const GET_DATA_FEEDS_URL = '/integrations/dataFeeds.json';
export const VALIDATE_DATE_FEED_URL = '/settings/dataFeeds/validate';
export const UPDATE_DATA_FEED_URL = '/settings/dataFeeds/update';

/**
 * Delete a data feed - requires non-typical key "dataFeedId" for API request
 * @param {string} id
 */
export const deleteDataFeed = (id: number) => post(DELETE_DATA_FEED_URL, { dataFeedId: id });

/**
 * Fetch the data feeds
 */
export const getDataFeeds = () => get(GET_DATA_FEEDS_URL);

/**
 * Validate a data feed
 */
export const validateDataFeed = (dataFeed: DataFeed | NewDataFeed) =>
  post(VALIDATE_DATE_FEED_URL, dataFeed);

/**
 * Create or Update a Data Feed
 */
export const updateDataFeed = (dataFeed: DataFeed | NewDataFeed) =>
  post(UPDATE_DATA_FEED_URL, dataFeed);
